import { render, staticRenderFns } from "./Citas.vue?vue&type=template&id=c5fd88b2&scoped=true"
import script from "./Citas.vue?vue&type=script&lang=js"
export * from "./Citas.vue?vue&type=script&lang=js"
import style0 from "./Citas.vue?vue&type=style&index=0&id=c5fd88b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fd88b2",
  null
  
)

export default component.exports